<template>
  <div id="course-create-details-tab" v-if="data" @keyup.ctrl.enter="lab_update_data">
    <div class="vx-col w-full">
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input v-model="dataLocal.username" class="w-full" label-placeholder="Account Username" />
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input v-model="dataLocal.password" class="w-full" label-placeholder="Account Password" />
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input v-model="dataLocal.assignmentId" class="w-full" label-placeholder="Account Assignment ID" />
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input v-model="dataLocal.accountId" class="w-full" label-placeholder="Account Vendor ID" />
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input v-model="dataLocal.userAgent" class="w-full" label-placeholder="Account User Agent" />
        </div>
        <div class="vx-col w-1/3">
          <p class="text-sm">Lab Pool ID</p>
          <v-select placeholder="Lab Pool ID" :options="pools" v-model="dataLocal.pool" class="mt-1" />
        </div>
      </div>
      <!---<div class="vx-row mb-6">
        <div class="vx-col w-full flex gap-2 items-center">
          <p class="text-md">Verify Account</p>
          <vs-switch v-model="dataLocal.login" class="self-center mr-2"/>
        </div>
      </div>--->

      <div class="vx-row">
        <div class="vx-col w-full flex gap-4">
          <vs-button class="mb-2" color="success" type="filled" @click="lab_update_data">Update Account </vs-button>
          <vs-button class="mb-2" color="danger" type="filled" @click="lab_refresh_data">Clear Account </vs-button>
          <vs-button class="mb-2" color="warning" type="border" @click="reset_data">Reset </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from 'axios'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      lab_description_counter: null,

      pools: [],

      status_options: ['active', 'hidden', 'disabled'],

      difficulties: [
        { id: '0', label: 'Simple' },
        { id: '1', label: 'Easy' },
        { id: '2', label: 'Moderate' },
        { id: '3', label: 'Hard' },
        { id: '4', label: 'Challenging' }
      ]
    }
  },
  components: {
    vSelect,
    VueJsonPretty
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    lab_update_data () {
      this.$emit('update_lab_data', this.dataLocal)
    },
    lab_refresh_data () {
      this.$emit('refresh_lab_data', this.dataLocal)
    },
    reset_data () {
      this.dataLocal = JSON.parse(JSON.stringify(this.data))
    },
    get_pools () {
      axios
        .get(`${process.env.VUE_APP_ROOT_LABS_API}/labs/pools`)
        .then((response) => {
          this.pools = response.data.rows.map((obj) => obj.id)
        })
        .catch((error) => {})
    }
  },
  created () {
    this.get_pools()
  }
}
</script>

<style scoped></style>
